<template>
	<div class="ventas-page">
		<div class="d-flex justify-content-between align-items-center mb-3">
			<div>
				<h1 class="mb-2">About</h1>
				<p class="text-muted">Edit the About page content freely with the rich text editor</p>
			</div>
			<div class="d-flex gap-3">
				<button type="button" class="btn btn-success" @click="submit">
					<i class="fa fa-save"></i> Save
				</button>
			</div>
		</div>

		<div class="ventas-card about-editor-card">
			<form role="form" @submit.prevent="submit">
				<label class="control-label mb-2">Content</label>
				<vue-editor
					id="aboutEditor"
					v-model="content.body"
					:editorToolbar="customToolbar"
					:editorOptions="editorOptions"
				></vue-editor>
				<div class="d-flex justify-content-end mt-4">
					<button type="submit" class="btn btn-success">
						<i class="fa fa-save"></i> Save Changes
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
	components: {
		VueEditor
	},
	data() {
		return {
			content: {
				body: ''
			},
			customToolbar: [
				[{ header: [false, 1, 2, 3, 4, 5, 6] }],
				[{ font: [] }],
				['bold', 'italic', 'underline', 'strike'],
				[{ color: [] }, { background: [] }],
				[{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
				[{ list: 'ordered' }, { list: 'bullet' }],
				[{ indent: '-1' }, { indent: '+1' }],
				['blockquote', 'code-block'],
				['link', 'image'],
				['clean']
			],
			editorOptions: {
				placeholder: 'Write your About page content here...'
			}
		}
	},
	methods: {
		getContent() {
			this.$root.isLoading = true
			axios.get(tools.url('/api/admin/about')).then((response) => {
				this.content.body = response.data.body || ''
				this.$root.isLoading = false
			}).catch((error) => {
				this.$root.handleErrors(error)
				this.$root.isLoading = false
			})
		},
		submit() {
			this.$root.isLoading = true
			axios.post(tools.url('/api/admin/about'), { body: this.content.body })
				.then((response) => {
					this.$root.showMessage(response.data.msg || 'About updated successfully', 'success')
					this.$root.isLoading = false
				}).catch((error) => {
					this.$root.handleErrors(error)
					this.$root.isLoading = false
				})
		}
	},
	mounted() {
		this.getContent()
	}
}
</script>

<style scoped>
.about-editor-card {
	padding: 24px;
}

/* Make Quill editor feel spacious and modern */
.about-editor-card >>> .quillWrapper {
	border-radius: 10px;
	overflow: hidden;
	border: 1px solid #e5e7eb;
}

.about-editor-card >>> .ql-toolbar.ql-snow {
	border: none;
	border-bottom: 1px solid #e5e7eb;
	background: #f8f9fb;
	padding: 10px 12px;
}

.about-editor-card >>> .ql-container.ql-snow {
	border: none;
	min-height: 420px;
	font-size: 15px;
	line-height: 1.65;
}

.about-editor-card >>> .ql-editor {
	min-height: 420px;
	padding: 20px 22px;
}

.about-editor-card >>> .ql-editor.ql-blank::before {
	color: #9ca3af;
	font-style: normal;
}
</style>
